export { default } from "./SectionTitle";
export * from "./SectionTitle";
